import Button from '@rio-cloud/rio-uikit/Button';
import { FunctionComponent } from 'react';
import { assertExhaustive } from '../../../../../utils';
import { NoValue } from '../../../sharedComponents/NoValue';
import { AllowedAction, InventoryVehicle } from '../../compoundManagement.types';
import {
    DisplayArrivalDate,
    DisplayArrivalFreightForwarder,
    DisplayArrivalFromCity,
    DisplayArrivalFromLocationId,
} from '../../shared/dataDisplay/ArrivalDataContent';
import { DisplayDispatchType } from '../../shared/dataDisplay/DisplayDispatchType';
import { DisplayFuelType } from '../../shared/dataDisplay/DisplayFuelType';
import { DisplayModelName } from '../../shared/dataDisplay/DisplayModelName';
import { DisplaySpecialInstructions } from '../../shared/dataDisplay/DisplaySpecialInstructions';
import { CompoundVehicleActionButton } from '../../shared/table/CompoundVehicleActionButton';
import { VehicleInventoryTableColumn } from './VehicleInventoryTableColumn';

type TableDataContentProps = {
    column: VehicleInventoryTableColumn;
    vehicle: InventoryVehicle;
};

export const VehicleInventoryTableDataContent: FunctionComponent<TableDataContentProps> = ({ vehicle, column }) => {
    const allowsArrival = vehicle.allowedActions.includes(AllowedAction.REPORT_ARRIVAL);
    const allowsUnannouncedDeparture = vehicle.allowedActions.includes(AllowedAction.REPORT_UNANNOUNCED_DEPARTURE);
    const spanOrNoValue = (text: string | undefined) => (text ? <span>{text}</span> : <NoValue />);

    switch (column) {
        case VehicleInventoryTableColumn.VIN:
            return <div className="ellipsis-1">{vehicle.vehicle.vin}</div>;
        case VehicleInventoryTableColumn.LOCATION_ID:
            return <span>{vehicle.compoundLocation.identifier}</span>;
        case VehicleInventoryTableColumn.LOCATION_CITY:
            return <span>{vehicle.compoundLocation.address.city}</span>;
        case VehicleInventoryTableColumn.MANUFACTURER:
            return spanOrNoValue(vehicle.vehicle.model.manufacturer);
        case VehicleInventoryTableColumn.MODEL:
            return <DisplayModelName vehicle={vehicle.vehicle} />;
        case VehicleInventoryTableColumn.DISPATCH_TYPE:
            return <DisplayDispatchType vehicle={vehicle.vehicle} />;
        case VehicleInventoryTableColumn.FUEL_TYPE:
            return <DisplayFuelType vehicle={vehicle.vehicle} />;
        case VehicleInventoryTableColumn.MODEL_VERSION:
            return spanOrNoValue(vehicle.vehicle.model.version);
        case VehicleInventoryTableColumn.SPECIAL_INSTRUCTIONS:
            return <DisplaySpecialInstructions specialInstructions={vehicle.vehicle.specialInstructions} />;
        case VehicleInventoryTableColumn.ARRIVAL_DATE:
            return <DisplayArrivalDate compoundVehicle={vehicle} />;
        case VehicleInventoryTableColumn.ARRIVAL_FROM_LOCATION_ID:
            return <DisplayArrivalFromLocationId compoundVehicle={vehicle} />;
        case VehicleInventoryTableColumn.ARRIVAL_FROM_CITY:
            return <DisplayArrivalFromCity compoundVehicle={vehicle} />;
        case VehicleInventoryTableColumn.ARRIVAL_FREIGHT_FORWARDER:
            return <DisplayArrivalFreightForwarder arrival={vehicle.arrival} />;
        case VehicleInventoryTableColumn.ACTION:
            return (
                (allowsArrival || allowsUnannouncedDeparture) && (
                    <CompoundVehicleActionButton
                        labelId="outboundPortal.compoundManagement.button.updateArrivalOrDeparture"
                        icon="rioglyph-refresh"
                        vehicle={vehicle}
                        buttonStyle={Button.DEFAULT}
                    />
                )
            );
        default:
            assertExhaustive(column);
    }
};
